export abstract class MobileParameters {
    // public static smartphoneMaxWidth = 830; // 768;
    // public static windowWidth = 830;
    public static minDesktopWidth = 1366;
    public static minPadWidth = 760; // with 1024x768
}
